import Url from 'urijs';
import { isEmpty } from 'lodash';

import { buildTargetUrlPreservingParams } from 'Utils/uri/uriUtils';
import { PHONE_URL_PROTOCOL } from './constants';

function getUrl(sUrl) {
  return new Url(sUrl);
}

function sameHostname(previousUrl, nextUrl) {
  return (
    isEmpty(nextUrl.hostname()) ||
    (previousUrl.hostname() === nextUrl.hostname() && previousUrl.port() === nextUrl.port())
  );
}

export function getSpaUrl(url) {
  return getUrl(url.pathname()).query(url.query()).hash(url.hash()).toString();
}

class DynamicLinkUtil {
  constructor(previousUrl, nextUrl, options) {
    if (!(this instanceof DynamicLinkUtil)) {
      // TODO: cleanup !!
      // eslint-disable-next-line no-constructor-return
      return new DynamicLinkUtil(previousUrl, nextUrl, options);
    }
    this.previousUrl = previousUrl ? getUrl(previousUrl) : new Url();
    this.nextUrl = getUrl(nextUrl);
    this.targetUrl = this.isExternalUrl()
      ? this.nextUrl
      : buildTargetUrlPreservingParams(this.previousUrl, this.nextUrl, options);
  }

  hashToSamePage() {
    return (
      !isEmpty(this.nextUrl.hash()) &&
      (isEmpty(this.nextUrl.pathname()) || this.nextUrl.pathname() === this.previousUrl.pathname())
    );
  }

  isOpenLayerLink() {
    return this.nextUrl.hasQuery('openLayer');
  }

  isPhoneNumberUrl() {
    return this.nextUrl.protocol() === PHONE_URL_PROTOCOL;
  }

  isExternalUrl() {
    return !sameHostname(this.previousUrl, this.nextUrl) || this.isPhoneNumberUrl();
  }

  isSpaUrl() {
    return !this.isExternalUrl() && !this.hashToSamePage() && !this.isPhoneNumberUrl();
  }

  toString() {
    return this.isSpaUrl() ? getSpaUrl(this.targetUrl) : this.targetUrl.toString();
  }

  hash() {
    return this.targetUrl.hash();
  }
}

export default DynamicLinkUtil;
